import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import getActorSection from '../../util/actor-field-generator';
import { focusOnErrors } from '../../util/validator';
import { ConfirmActors } from './confirm-actors';
const BoardActorsSection = _ref => {
  var _countries$countries;
  let {
    onSubmit,
    corporateBoardActorsSection,
    countries
  } = _ref;
  const {
    ceo,
    boardChairman,
    boardMembers
  } = corporateBoardActorsSection;
  const countryOptions = countries === null || countries === void 0 || (_countries$countries = countries.countries) === null || _countries$countries === void 0 ? void 0 : _countries$countries.map((country, i) => {
    return {
      text: country.text,
      value: country.iso3,
      key: (i + 1).toString()
    };
  });
  const getCitizenshipAsJoinedString = citizenship => {
    return citizenship === null || citizenship === void 0 ? void 0 : citizenship.map(country => country.text).join(', ');
  };
  const getInitialValues = () => {
    const getInitialActorObject = actor => {
      var _actor$address, _actor$address2, _actor$address3, _actor$address4, _actor$address5, _actor$address6, _actor$countryOfBirth;
      return {
        isFromServer: true,
        firstName: actor.firstName,
        lastName: actor.lastName,
        publicId: actor.publicId,
        //    Address fields
        addressLine1: (_actor$address = actor.address) === null || _actor$address === void 0 ? void 0 : _actor$address.addressLines[0],
        addressLine2: (_actor$address2 = actor.address) === null || _actor$address2 === void 0 ? void 0 : _actor$address2.addressLines[1],
        addressLine3: (_actor$address3 = actor.address) === null || _actor$address3 === void 0 ? void 0 : _actor$address3.addressLines[2],
        postalCode: (_actor$address4 = actor.address) === null || _actor$address4 === void 0 || (_actor$address4 = _actor$address4.postalCode) === null || _actor$address4 === void 0 ? void 0 : _actor$address4.code,
        postalArea: (_actor$address5 = actor.address) === null || _actor$address5 === void 0 || (_actor$address5 = _actor$address5.postalArea) === null || _actor$address5 === void 0 ? void 0 : _actor$address5.value,
        country: (_actor$address6 = actor.address) === null || _actor$address6 === void 0 || (_actor$address6 = _actor$address6.country) === null || _actor$address6 === void 0 ? void 0 : _actor$address6.iso3,
        citizenship: getCitizenshipAsJoinedString(actor.citizenship),
        birthCountry: (_actor$countryOfBirth = actor.countryOfBirth) === null || _actor$countryOfBirth === void 0 ? void 0 : _actor$countryOfBirth.iso3
      };
    };
    const initialValuesObject = {};
    if (ceo) {
      initialValuesObject.ceo = getInitialActorObject(ceo);
    }
    if (boardChairman) {
      initialValuesObject.boardChairman = getInitialActorObject(boardChairman);
    }
    if (boardMembers) {
      initialValuesObject.boardMembers = [];
      boardMembers.forEach((member, index) => {
        initialValuesObject.boardMembers[index] = getInitialActorObject(member);
      });
    }
    return initialValuesObject;
  };
  const initialValues = useMemo(getInitialValues, [ceo, boardChairman, boardMembers]);
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: () => {
      /* noop, handled by ConfirmActors */
    },
    decorators: [focusOnErrors],
    initialValues: initialValues,
    mutators: {
      setValueOfField: (args, state, utils) => {
        utils.changeValue(state, args[0].key, () => args[0].value);
      }
    }
  }, () => {
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      className: "ceo-section"
    }, /*#__PURE__*/React.createElement("h2", null, "Daglig leder"), ceo ? getActorSection(ceo !== null && ceo !== void 0 ? ceo : {}, 'ceo', countryOptions, true) : /*#__PURE__*/React.createElement("span", null, "Daglig leder ikke funnet")), /*#__PURE__*/React.createElement("div", {
      className: "board-chairman-section"
    }, /*#__PURE__*/React.createElement("h2", null, "Styreleder"), boardChairman ? getActorSection(boardChairman !== null && boardChairman !== void 0 ? boardChairman : {}, 'boardChairman', countryOptions, true) : /*#__PURE__*/React.createElement("span", null, "Styreleder ikke funnet")), /*#__PURE__*/React.createElement("div", {
      className: "board-member-section"
    }, /*#__PURE__*/React.createElement("h2", null, "Styremedlemmer"), boardMembers && boardMembers.length > 0 ? boardMembers.map((boardMember, index) => /*#__PURE__*/React.createElement("span", {
      key: "boardMember_".concat(boardMember.firstName, "_").concat(boardMember.lastName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "extra-margin-top"
    }, "Styremedlem #".concat(index + 1)), getActorSection(boardMember, "boardMembers[".concat(index, "]"), countryOptions, true))) : /*#__PURE__*/React.createElement("span", null, "Ingen styremedlemmer funnet")), /*#__PURE__*/React.createElement(ConfirmActors, {
      actors: {
        typeInfo: 'CEO_CHAIRMAN_BOARD_V2',
        ceo: corporateBoardActorsSection.ceo,
        chairman: corporateBoardActorsSection.boardChairman,
        board: corporateBoardActorsSection.boardMembers
      },
      onConfirmed: onSubmit
    }));
  });
};
export default BoardActorsSection;